import React, { FC, useMemo } from "react";
import CampaignsLoader from "Loader/Dashboard";
import { useDispatch, useSelector } from "react-redux";
import { IState } from "store/store.interface";
import {
  fetchBundleCampaigns,
  searchForBundleCampaigns,
  updateBundlePageNumber,
} from "store/actions/bundlePromotion.actions";
import { useApiInfo } from "hooks";
import { BUNDLE_PROMOTION_FETCH_CAMPAIGNS } from "store/store.types";
import { isEmpty } from "utils/app.utils";
import { Box, Link } from "common";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { useStyles } from "../../Dashboard/Dashboard.style";

const LoadMoreBundleCampaign: FC<{ title?: string; testId?: string }> = ({
  title = "Show more",
  testId = "load-more-link",
}) => {
  const classes = useStyles({});
  const { bundleDashboard, total, limit, page, filters } = useSelector(
    (state: IState) => ({
    ...state.bundlePromotion,
    ...state.config,
    ...state.auth,
    })
  );

  const { searchTerm } = useSelector((state: IState) => state.promotion);

  const { isLoading: isFetchingBundleCampaigns } = useApiInfo(
    BUNDLE_PROMOTION_FETCH_CAMPAIGNS
  );
  const dispatch = useDispatch();

  const onClick = () => {
    if (shouldShowLoadMore) {
      const newPageNumber = page + 1;
      dispatch(updateBundlePageNumber(newPageNumber));
      if (searchTerm) {
        dispatch(searchForBundleCampaigns({ searchTerm, page: newPageNumber }));
      } else {
        dispatch(fetchBundleCampaigns({ page: newPageNumber, filters }));
      }
    }
  };

  const isLoading = useMemo(() => {
    return isFetchingBundleCampaigns && !isEmpty(bundleDashboard);
  }, [isFetchingBundleCampaigns, bundleDashboard]);

  const shouldShowLoadMore = useMemo(() => {
    return (page + 1) * limit <= total + limit;
  }, [page, limit, total]);

  if (shouldShowLoadMore) {
    if (isLoading) {
      return <CampaignsLoader />;
    }
    return (
      <Box
        mt="30px"
        display="flex"
        data-testid={testId}
        justifyContent="center"
        alignItems="center"
      >
        <Link
          data-testid="load-more-button"
          variant="default"
          color="primary"
          onClick={onClick}
          className={classes.loadMore}
        >
          <Box
            fontSize="16px"
            display="flex"
            alignItems="center"
            flexDirection="column"
          >
            <span>{title}</span>
            <ExpandMore color="primary" />
          </Box>
        </Link>
      </Box>
    );
  }
  return null;
};

export default LoadMoreBundleCampaign;
